import { render, staticRenderFns } from "./CMDirectPaymentsSettingsPage.vue?vue&type=template&id=0224e36c&scoped=true&"
import script from "./CMDirectPaymentsSettingsPage.vue?vue&type=script&lang=js&"
export * from "./CMDirectPaymentsSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./CMDirectPaymentsSettingsPage.vue?vue&type=style&index=0&id=0224e36c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0224e36c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0224e36c')) {
      api.createRecord('0224e36c', component.options)
    } else {
      api.reload('0224e36c', component.options)
    }
    module.hot.accept("./CMDirectPaymentsSettingsPage.vue?vue&type=template&id=0224e36c&scoped=true&", function () {
      api.rerender('0224e36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/CMDirectPaymentsSettingsPage.vue"
export default component.exports